import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserLogin, User } from '../../component/model/user-login';
import { AuthServiceService } from '../../component/service/auth-service.service';
import { UserService } from '../user/service/user.service';
import { Router} from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../../assets/css/login.css', 'login.component.css']
})
export class LoginComponent implements OnInit {
  errorMsg : string = '';
  user : User = new User('','');
  authService : AuthServiceService;
  router: Router;
  loading : boolean = false;
  type="password"
  @ViewChild('password') pwd: ElementRef;
  constructor(authorizationService : AuthServiceService, route :Router ,private _UserService: UserService ) {
    this.authService = authorizationService;
    this.router = route;
   }
  
  ngOnInit() {
    $('body').addClass("login-page authentication");
  }

  showTextC() {
    if(this.type==='password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  login() {
    this.loading = true;
    this.errorMsg = ""; 
    this.authService.login(this.user).subscribe(data=> {
      this.authService.setLoginDetail(data.access_token, +data.expires_in, this.user.email);
      let t = +data.expires_in;
      this._UserService.getUserProfile().subscribe(data=>{
        if(data.length>0) {
          this.authService.setUserDetail(data[0].OrganizationId.toString(), data[0].UserRoleId.toString(), t);
         sessionStorage.setItem("User",JSON.stringify(data[0]));
         window.location.reload(); 
       }
      })   
     // this.router.navigate(['main']);
      this.loading = false;
     }, error=> {
      this.errorMsg = JSON.parse(error._body).error_description;
      this.loading = false;
    });
  }
 
}



// WEBPACK FOOTER //
// ./src/app/section/login/login.component.ts